"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _reactRouterDom = require("react-router-dom");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Table = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Table"));
var _Actions = _interopRequireDefault(require("@mulesoft/exchange-ui-components/lib/components/Actions"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var eventsUtils = _interopRequireWildcard(require("../../utils/events"));
var _portals = require("../../utils/portals");
var filesUtils = _interopRequireWildcard(require("../../utils/files"));
var _ActionAssetItem = _interopRequireDefault(require("../Actions/ActionAssetItem/ActionAssetItem"));
var _VersionInfoModal = _interopRequireDefault(require("./VersionInfoModal"));
var _LifecycleState = _interopRequireDefault(require("../LifecycleState"));
var _LifecycleStatePill = _interopRequireDefault(require("../LifecycleState/LifecycleStatePill"));
var _MenuActions = _interopRequireDefault(require("./MenuActions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DownloadIcon = function DownloadIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 14a1 1 0 0 1 1 1v4h14v-4a1 1 0 1 1 2 0v4c0 1.103-.898 2-2 2H5c-1.102 0-2-.897-2-2v-4a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.707 16.705a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414l1.295 1.295.008-9.559c0-.552.438-1 .99-.999.552 0 1.01.449 1.01 1.001l-.008 9.553 1.29-1.29a1 1 0 0 1 1.415 1.413l-3 3z"
  }));
};
DownloadIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var PlusIcon = function PlusIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  }));
};
PlusIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var DeprecateIcon = function DeprecateIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
DeprecateIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var TrashIcon = function TrashIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 3.947C7 2.704 8.143 2 9.143 2h5.714c1 0 2.143.704 2.143 1.947V5h3a1 1 0 1 1 0 2h-.198l-.75 13.114A2 2 0 0 1 17.056 22H6.945a2 2 0 0 1-1.997-1.886L4.198 7H4a1 1 0 0 1 0-2h3V3.947zM9 5h6V4H9v1zM6.202 7l.743 13h10.11L17.8 7H6.202zM10 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1z"
  }));
};
TrashIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "versions-table": "VersionsTable__versions-table__eFOxE",
  "versionsTable": "VersionsTable__versions-table__eFOxE",
  "menu-item": "VersionsTable__menu-item__1nBWn",
  "menuItem": "VersionsTable__menu-item__1nBWn",
  "popover-action": "VersionsTable__popover-action__1c-zl",
  "popoverAction": "VersionsTable__popover-action__1c-zl",
  "disabled": "VersionsTable__disabled__2nMvL",
  "deprecate-icon": "VersionsTable__deprecate-icon__34_DA",
  "deprecateIcon": "VersionsTable__deprecate-icon__34_DA",
  "delete-icon": "VersionsTable__delete-icon__2SXFM",
  "deleteIcon": "VersionsTable__delete-icon__2SXFM",
  "table-container": "VersionsTable__table-container__3AbfA",
  "tableContainer": "VersionsTable__table-container__3AbfA",
  "has-deprecated": "VersionsTable__has-deprecated__1VGAE",
  "hasDeprecated": "VersionsTable__has-deprecated__1VGAE",
  "new-version": "VersionsTable__new-version__iH8gD",
  "newVersion": "VersionsTable__new-version__iH8gD",
  "download-icon": "VersionsTable__download-icon__28zmY",
  "downloadIcon": "VersionsTable__download-icon__28zmY"
}; 
require('./VersionsTable.css');
function hasDeprecatedVersion() {
  var versions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return versions.some(function (version) {
    return version.status === 'deprecated';
  });
}
var getModalContextCustom = (0, _memoizeOne.default)(function (useOpenModal, modalContext) {
  return _objectSpread(_objectSpread({}, modalContext), {}, {
    openModal: useOpenModal ? modalContext.openModal : modalContext.pushModal
  });
});
var VersionsTable = exports.default = /*#__PURE__*/function (_React$Component) {
  function VersionsTable() {
    var _this;
    (0, _classCallCheck2.default)(this, VersionsTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, VersionsTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "handleClick", function (file) {
      var onDownload = _this.props.onDownload;
      if (!file.isDisabled) {
        onDownload(file);
      }
    });
    return _this;
  }
  (0, _inherits2.default)(VersionsTable, _React$Component);
  return (0, _createClass2.default)(VersionsTable, [{
    key: "handleDownload",
    value: function handleDownload(event, file) {
      event.preventDefault();
      var _this$props = this.props,
        onDownload = _this$props.onDownload,
        isStudio = _this$props.isStudio,
        getPath = _this$props.router.getPath;
      if (!file.isDisabled) {
        onDownload(file);
        filesUtils.download(file, isStudio, getPath);
      }
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(assetVersion) {
      var _this$props2 = this.props,
        assetVersions = _this$props2.assetVersions,
        closeModal = _this$props2.closeModal,
        isPortalReArchitectureEnabled = _this$props2.isPortalReArchitectureEnabled;
      if (!isPortalReArchitectureEnabled) {
        return;
      }
      var remainingVersions = assetVersions.filter(function (_ref) {
        var version = _ref.version;
        return version !== assetVersion.version;
      });
      if (remainingVersions.length === 0) {
        closeModal();
      }
    }
  }, {
    key: "getFilesItems",
    value: function getFilesItems(assetVersion) {
      var _this2 = this;
      var _this$props3 = this.props,
        getPath = _this$props3.router.getPath,
        isStudio = _this$props3.isStudio,
        profile = _this$props3.profile,
        studioMetadata = _this$props3.studioMetadata,
        config = _this$props3.config,
        portalFiles = _this$props3.files;
      var isUserAuthorized = !!profile;
      var files = !isUserAuthorized ? [] : (0, _portals.getTypeFiles)(portalFiles, assetVersion, studioMetadata, 'versions-table', config).files;
      var hasFiles = files && files.length > 0;
      if (!hasFiles || isStudio) {
        return [];
      }
      return files.map(function (file, index) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          className: styles.menuItem,
          key: file.label,
          onKeyDown: eventsUtils.onEnterKey(function (event) {
            return _this2.handleDownload(event, file);
          })
        }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
          testId: "download-version-action-".concat(index),
          className: (0, _classnames.default)(styles.popoverAction, (0, _defineProperty2.default)({}, styles.disabled, file.isDisabled)),
          tooltip: file.isDisabled ? file.disabledTooltip : null,
          key: file.label,
          href: file.isDisabled ? null : filesUtils.getFileURL(file, getPath),
          onClick: function onClick() {
            return _this2.handleClick(file);
          },
          icon: /*#__PURE__*/_react.default.createElement(DownloadIcon, null),
          label: file.actionsLabel || (file.label ? "Download as ".concat(file.label) : 'Download')
        }));
      });
    }
  }, {
    key: "getHeaders",
    value: function getHeaders(openModal) {
      var _this3 = this;
      var _this$props4 = this.props,
        asset = _this$props4.asset,
        assetVersions = _this$props4.assetVersions,
        _this$props4$componen = _this$props4.components,
        Actions = _this$props4$componen.Actions,
        DeleteAssetModal = _this$props4$componen.DeleteAssetModal,
        DeprecateAssetModal = _this$props4$componen.DeprecateAssetModal,
        RevertDeprecateAssetModal = _this$props4$componen.RevertDeprecateAssetModal,
        canAdmin = _this$props4.canAdmin,
        isEdit = _this$props4.isEdit,
        isDraft = _this$props4.isDraft,
        isStudio = _this$props4.isStudio,
        isTypeLoaded = _this$props4.isTypeLoaded,
        isPortalReArchitectureEnabled = _this$props4.isPortalReArchitectureEnabled,
        isDeleteVersionsTable = _this$props4.isDeleteVersionsTable,
        additionalHeaders = _this$props4.additionalHeaders,
        onOpen = _this$props4.onOpen,
        onClose = _this$props4.onClose;
      var headers = [];
      if (hasDeprecatedVersion(assetVersions)) {
        headers.push({
          label: 'Status',
          hidden: true,
          render: function render(assetVersion) {
            return assetVersion.status === 'deprecated' ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
              role: "img",
              title: "Deprecated version",
              "aria-label": "Deprecated version",
              size: "xs",
              fill: "#ffcc00"
            }, /*#__PURE__*/_react.default.createElement(DeprecateIcon, null)) : null;
          }
        });
      }
      headers.push({
        label: 'Version',
        render: function render(assetVersion) {
          return /*#__PURE__*/_react.default.createElement("span", null, assetVersion.version);
        }
      });
      if (isPortalReArchitectureEnabled) {
        headers.push({
          label: 'Lifecycle state',
          render: function render(assetVersion) {
            return isDeleteVersionsTable ? /*#__PURE__*/_react.default.createElement(_LifecycleStatePill.default, {
              lightTheme: true,
              status: assetVersion.status
            }) : /*#__PURE__*/_react.default.createElement(_LifecycleState.default, {
              lightTheme: true,
              asset: assetVersion,
              hideIcon: true
            });
          }
        });
      }
      headers.push.apply(headers, (0, _toConsumableArray2.default)(additionalHeaders()));
      if (!isEdit && !isDeleteVersionsTable) {
        headers.push({
          label: 'Actions',
          hidden: true,
          render: function render(assetVersion) {
            if (isTypeLoaded === false) {
              return null;
            }
            var filesItems = _this3.getFilesItems(assetVersion);
            var showDeleteAsset = canAdmin && !isStudio;
            var showDeprecateAsset = !isPortalReArchitectureEnabled && canAdmin && assetVersion.status !== 'deprecated' && !isStudio;
            var showRevertDeprecateAsset = !isPortalReArchitectureEnabled && canAdmin && assetVersion.status === 'deprecated' && !isStudio;
            Actions.displayName = 'Actions';
            var openVersionInfoModal = function openVersionInfoModal() {
              openModal(_VersionInfoModal.default, {
                asset: assetVersion,
                isPortalReArchitectureEnabled: isPortalReArchitectureEnabled
              });
            };
            var openDeprecateAssetModal = function openDeprecateAssetModal() {
              return openModal(DeprecateAssetModal, {
                asset: assetVersion
              });
            };
            var onRevertDeprecateAssetModal = function onRevertDeprecateAssetModal() {
              return openModal(RevertDeprecateAssetModal, {
                asset: assetVersion
              });
            };
            var onDeleteAssetModal = function onDeleteAssetModal() {
              return openModal(DeleteAssetModal, {
                asset: assetVersion,
                isCurrent: asset.version === assetVersion.version,
                onDelete: function onDelete() {
                  return _this3.handleDelete(assetVersion);
                }
              });
            };
            return /*#__PURE__*/_react.default.createElement(_Actions.default, {
              onClose: onClose,
              onOpen: onOpen,
              renderMenu: function renderMenu(_ref2) {
                var children = _ref2.children;
                return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_MenuActions.default, null, children));
              }
            }, filesItems, /*#__PURE__*/_react.default.createElement(Actions, {
              asset: assetVersion,
              isDraft: isDraft,
              isEdit: isEdit,
              section: "versions-table"
            }), /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
              className: styles.menuItem,
              testId: "version-detail-action",
              onKeyDown: eventsUtils.onEnterKey(openVersionInfoModal)
            }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
              onClick: openVersionInfoModal,
              className: styles.popoverAction,
              icon: /*#__PURE__*/_react.default.createElement(InfoIcon, null),
              label: "Version detail",
              testId: "version-detail-action-item",
              description: "Opens version detail modal"
            })), showDeprecateAsset ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
              className: styles.menuItem,
              testId: "deprecate-version-action",
              onKeyDown: eventsUtils.onEnterKey(openDeprecateAssetModal)
            }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
              onClick: openDeprecateAssetModal,
              className: styles.popoverAction,
              iconClassName: styles.deprecateIcon,
              icon: /*#__PURE__*/_react.default.createElement(PlusIcon, null),
              label: "Deprecate version",
              testId: "deprecate-version-action-item",
              description: "Opens deprecate version modal"
            })) : null, showRevertDeprecateAsset ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
              className: styles.menuItem,
              testId: "revert-deprecate-version-action",
              onKeyDown: eventsUtils.onEnterKey(onRevertDeprecateAssetModal)
            }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
              onClick: onRevertDeprecateAssetModal,
              className: styles.popoverAction,
              iconClassName: styles.deprecateIcon,
              icon: /*#__PURE__*/_react.default.createElement(PlusIcon, null),
              description: "Opens revert deprecate version modal",
              label: "Revert deprecate version",
              testId: "revert-deprecate-action-item"
            })) : null, showDeleteAsset ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
              className: styles.menuItem,
              testId: "delete-version-action",
              onKeyDown: eventsUtils.onEnterKey(onDeleteAssetModal)
            }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
              onClick: onDeleteAssetModal,
              className: styles.popoverAction,
              icon: /*#__PURE__*/_react.default.createElement(TrashIcon, null),
              description: "Opens delete version modal",
              label: "Delete version",
              testId: "delete-version-action-item"
            })) : null);
          }
        });
      } else if (!isEdit && isDeleteVersionsTable) {
        headers.push({
          label: 'Delete',
          hidden: true,
          render: function render(assetVersion) {
            return /*#__PURE__*/_react.default.createElement(_Button.default, {
              size: "md",
              testId: "delete-versions-button",
              kind: null,
              noFill: true,
              className: styles.deleteIcon,
              onClick: function onClick() {
                return openModal(DeleteAssetModal, {
                  asset: assetVersion,
                  isCurrent: asset.version === assetVersion.version,
                  onDelete: function onDelete() {
                    return _this3.handleDelete(assetVersion);
                  }
                });
              }
            }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
              "data-test-id": "delete-version-icon",
              "aria-label": "Delete patch version",
              className: styles.icon
            }, /*#__PURE__*/_react.default.createElement(TrashIcon, null)));
          }
        });
      }
      return headers;
    }
  }, {
    key: "render",
    value: function render() {
      var _assetTypesConfigurat, _assetTypesConfigurat2;
      var _this$props5 = this.props,
        asset = _this$props5.asset,
        assetVersions = _this$props5.assetVersions,
        assetTypesConfiguration = _this$props5.assetTypesConfiguration,
        config = _this$props5.config,
        canEdit = _this$props5.canEdit,
        isDraft = _this$props5.isDraft,
        openModal = _this$props5.openModal,
        pushModal = _this$props5.pushModal,
        useOpenModal = _this$props5.useOpenModal,
        onAddNewVersion = _this$props5.onAddNewVersion,
        getPath = _this$props5.router.getPath,
        profile = _this$props5.profile,
        isDeleteVersionsTable = _this$props5.isDeleteVersionsTable;
      var renderModal = useOpenModal ? openModal : pushModal;
      var headers = this.getHeaders(renderModal);
      var canAddVersion = !isDeleteVersionsTable && canEdit && !isDraft && !!((_assetTypesConfigurat = assetTypesConfiguration[asset.type]) !== null && _assetTypesConfigurat !== void 0 && (_assetTypesConfigurat2 = _assetTypesConfigurat.form) !== null && _assetTypesConfigurat2 !== void 0 && (_assetTypesConfigurat2 = _assetTypesConfigurat2.call(_assetTypesConfigurat, {
        profile: profile,
        config: config,
        latestAsset: asset
      })) !== null && _assetTypesConfigurat2 !== void 0 && (_assetTypesConfigurat2 = _assetTypesConfigurat2.flows) !== null && _assetTypesConfigurat2 !== void 0 && _assetTypesConfigurat2.length);
      return /*#__PURE__*/_react.default.createElement("section", {
        "data-test-id": "asset-versions-table",
        className: styles.versionsTable,
        "aria-labelledby": "versions-table-heading"
      }, useOpenModal ? /*#__PURE__*/_react.default.createElement("h4", {
        id: "versions-table-heading"
      }, "Asset versions for ", asset.minorVersion, ".x") : null, /*#__PURE__*/_react.default.createElement(_exchangeReactHooks.ModalContext.Consumer, null, function (modalContext) {
        return /*#__PURE__*/_react.default.createElement(_exchangeReactHooks.ModalContext.Provider, {
          value: getModalContextCustom(useOpenModal, modalContext)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: styles.tableContainer
        }, /*#__PURE__*/_react.default.createElement(_Table.default, {
          caption: "Asset versions",
          className: (0, _classnames.default)((0, _defineProperty2.default)({}, styles.hasDeprecated, hasDeprecatedVersion(assetVersions))),
          headers: headers,
          isRowSelected: function isRowSelected() {
            return false;
          },
          rows: assetVersions,
          testId: "asset-versions"
        })));
      }), canAddVersion ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        className: styles.newVersion,
        to: getPath('newVersion', asset),
        "data-test-id": "add-version-action",
        onClick: function onClick() {
          return onAddNewVersion(asset);
        }
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        size: "s"
      }, /*#__PURE__*/_react.default.createElement(PlusIcon, null)), "Add new version") : null);
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(VersionsTable, "defaultProps", {
  additionalHeaders: function additionalHeaders() {
    return [];
  },
  canEdit: false,
  isDraft: false,
  isEdit: false,
  useOpenModal: true,
  onAddNewVersion: function onAddNewVersion() {},
  onDownload: function onDownload() {},
  isDeleteVersionsTable: false,
  onClose: function onClose() {},
  onOpen: function onOpen() {}
});
//# sourceMappingURL=VersionsTable.js.map